import React, { useState } from 'react';
import { Tooltip } from 'antd';
import style from './TooltipForText.module.scss';

const TooltipForText: React.FC = React.memo(({ children }) => {
	const [isVisibleTooltip, setIsVisibleTooltip] = useState<boolean>(false);

	const handleOnMouse = (e: React.MouseEvent<HTMLDivElement>): void => {
		if (e.currentTarget.clientWidth < e.currentTarget.scrollWidth) {
			setIsVisibleTooltip(true);
		}
	};

	return (
		<Tooltip
			overlayInnerStyle={{
				padding: '7px 12px',
				borderRadius: '3px',
				fontSize: '15px',
				fontWeight: 600,
				color: '#5B32B4',
			}}
			color="#D4CDE4"
			visible={isVisibleTooltip}
			title={children}
			placement="topLeft">
			<div className={style.text} onMouseEnter={handleOnMouse} onMouseOut={() => setIsVisibleTooltip(false)}>
				{children}
			</div>
		</Tooltip>
	);
});

export default TooltipForText;
